import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { ConfigurationsService } from '@icc/configurator/shared';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared';
import { ICC_PAGE_DATA, PageComponent } from '@icc/configurator/shared';
import { iccListItem } from '@icc/configurator/ui';
import { IccAccessoryAccessory, IccAccessoryColor } from '@icc/construction-elements/types';
import { SharedFacade } from '@icc/configurator/shared';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ColorMappingService } from '@icc/construction-elements/configurator';
import { KeysService } from '../cylinders-page/keys.service';

@Component({
    selector: 'icc-hardware-type-options-page',
    templateUrl: './hardware-type-options-page.component.html',
    styleUrls: ['./hardware-type-options-page.component.scss'],
    standalone: false
})
export class HardwareTypeOptionsPageComponent extends PageComponent implements OnInit {
    public title: string = _('DOOR|Opcje osprzętu');
    selectedType: IccAccessoryAccessory | null = null;
    colors: iccListItem[] = [];
    selColor = 0;
    defaultColor = false;

    maxKeyQuantity = 0;
    keyPrice = 0;
    listKeyPrice = 0;
    hiddenPrice = false;

    selectedTypeImg = '';

    cylinderKeysForm: UntypedFormGroup;
    currency = null;

    constructor(
        @Inject(APP_CONFIG) public config: AppConfigFactory,
        private sharedFacade: SharedFacade,
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            title: string;
            selectedType: IccAccessoryAccessory;
            hardwareColors?: IccAccessoryColor[];
            selColor: IccAccessoryColor;
            colorIdToMapping: number | null;
        },
        private configurationsService: ConfigurationsService<'door'>,
        private colorsMappingService: ColorMappingService,
        private fb: UntypedFormBuilder,
        private keysService: KeysService,
    ) {
        super();
        if(pageData.title) {
            this.title = pageData.title;
        }
    }

    ngOnInit() {
        this.hiddenPrice = this.config().preset === 'b2c' && this.config().hidePricesInB2cConfigurator;

        this.sharedFacade.currency$.subscribe((currency) => {
            this.currency = currency;
        });
        this.selectedType = this.pageData.selectedType;
        this.selColor = this.pageData.selColor && Number(this.pageData.selColor.id);
        this.defaultColor = Boolean(this.pageData.selColor && this.pageData.selColor.isDefault);
        this.colors = !this.pageData.hardwareColors ? [] : this.pageData.hardwareColors
            .filter(
                color =>
                    this.selectedType
                    && this.selectedType.colors_ids
                    && this.selectedType.colors_ids.some(id => Number(id) === Number(color.id))
            )
            .map(color => ({
                id: color.id,
                title: color.name,
                color: '#' + color.color,
                imageUrl: '/files/windowhandlescolor/' + color.color_img,
            }));
        this.setDefaultColors();
        this.selectedTypeImg = this.getImageUrl(this.selectedType, String(this.selColor));

        if(this.selectedType.type === 'cylinder') {
            this.cylinderKeyForm();
            this.keyPrice = this.selectedType.key_price;
            this.listKeyPrice = this.selectedType.list_key_price;
            this.maxKeyQuantity = Number(this.selectedType.max_key_quantity);
        }
    }


    cylinderKeyForm(conf = this.configurationsService.conf.Current.doorHardware.cylinders) {
        const mainLock = conf.keyQuantityForMainLock;
        const additionalLock = conf.keyQuantityForAdditionalLock;

        this.cylinderKeysForm = this.fb.group({
            key: [
                this.selectedType.fits_the_lock ? additionalLock : mainLock,
                Validators.compose([
                    Validators.min(0),
                    Validators.max(this.selectedType.max_key_quantity),
                ]),
            ],
        });
    }

    private setDefaultColors() {
        if (((this.pageData.selectedType && this.pageData.selectedType.colors_ids) || []).map(String).indexOf(String(this.selColor)) === -1) {
            const hardwareColorsIds = ((this.pageData.selectedType && this.pageData.selectedType.colors_ids) || []).map(Number);
            const matchedColors = this.colorsMappingService.getMappedColorsFromAccessory(this.pageData.colorIdToMapping);
            const colors = (matchedColors || [])
                .map(m => hardwareColorsIds.filter(c => c === m)[0])
                .filter(m => m);
            if (colors.length) {
                this.selColor = colors[0];
            } else if(hardwareColorsIds.length > 0) {
                this.selColor = hardwareColorsIds[0];
            }
            this.defaultColor = true;
        }
    }

    private getImageUrl(hardware: IccAccessoryAccessory, selectedColor: string): string {
        return hardware && (hardware.colors_imgs && hardware.colors_imgs[selectedColor]
            ? '/files/windowhandlescolorswindowaccessory/' + hardware.colors_imgs[selectedColor]
            : '/files/windowaccessory/' + hardware.img);
      }

    selectColor(colorItem: iccListItem) {
        const type = this.pageData.selectedType;
        const color = this.pageData.hardwareColors.find(c => c.id === colorItem.id);
        if (type && color) {
            this.selColor = Number(color.id);
            this.defaultColor = false;
            this.selectedTypeImg = this.getImageUrl(type, String(this.selColor));
        }
    }

    save() {
        if(this.selectedType.type === 'cylinder') {
            const keyQuantity = this.cylinderKeysForm.get('key').value;

            if (keyQuantity) {
                this.keysService.setKeyQuantityForCylinder(keyQuantity, this.selectedType);
            } else {
                this.keysService.setKeyQuantityForCylinder(0, this.selectedType);
            }
        }

        this.sharedFacade.closePage({
            type: this.pageData.selectedType,
            color: this.selColor,
            defaultColor: this.defaultColor,
        });
    }

    getColorName() {
        return this.colors.find(c => c.id === this.selColor)?.title || '';
    }
}
